import VueResize from 'vue-resize-mixin';
import cookie from 'js-cookie';

const helpers = {
  mixins: [VueResize],
  data() {
    return {
      screenWidth: Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      )
    };
  },
  created() {
    window.addEventListener('resize', this.screenWidthChanged);
  },
  destroyed() {
    window.removeEventListener('resize', this.screenWidthChanged);
  },
  methods: {
    screenWidthChanged() {
      this.screenWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
    },
    screenWidthGreaterThan(point) {
      return this.screenWidth > point;
    },

    screenWidthLessThan(point) {
      return this.screenWidth < point;
    },

    pageIsContent() {
      return document.querySelector('body').className.indexOf('content') !== -1;
    },

    setResourceCookie(resource) {
      cookie.set('_sk_resource', resource);
    },

    getRandomId() {
      // the following creates a random number, multiplies by 65536 (0x10000),
      // floors it with the pipe, converts it to hexadecimal, and then grabs
      // the last 4 characters with substring
      const fourCharString = () =>
        (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      return `${fourCharString()}${fourCharString()}-${fourCharString()}`;
    }
  }
};

export default helpers;
